import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en.json";
import ruTranslations from "./locales/ru.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    ru: {
      translation: ruTranslations,
    },
  },
  lng: "ru",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  pluralSeparator: "_",
  keySeparator: ".",
  nsSeparator: ":",
  react: {
    useSuspense: false,
  },
  pluralRules: {
    ru: {
      numbers: [1, 2, 4],
      plurals: function (n) {
        if (n % 10 === 1 && n % 100 !== 11) return 0; // one
        if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20))
          return 1; // few
        return 2; // many
      },
    },
  },
});

export default i18n;
